import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../reducers/rootReducer';

import { SET_CATEGORY, SET_ITEMS, SET_SELECTED, SET_INDEX_UPDATE_PREVIEW, SET_PREVIEW_POSITION } from '../constants/previewConstants';

export default function CanvasActions() {
   const dispatch = useDispatch();

   const category = useSelector((state: RootState) => state.previewReducer.category);
   const items = useSelector((state: RootState) => state.previewReducer.items);
   const selected = useSelector((state: RootState) => state.previewReducer.selected);
   const index = useSelector((state: RootState) => state.previewReducer.index);
   const previewPosition = useSelector((state: RootState) => state.previewReducer.previewPosition);

   const setCategory: Function = (category) => {
      dispatch({ type: SET_CATEGORY, category: category });
   }

   const setItems: Function = (items) => {
      dispatch({ type: SET_ITEMS, items: [...items] });
   }

   const setSelected: Function = (selected) => {
      dispatch({ type: SET_SELECTED, selected: [...selected] });
   }

   const setUpdatePreview: Function = (index) => {
      dispatch({ type: SET_INDEX_UPDATE_PREVIEW, index: index });
   }

   
   const setPreviewPosition: Function = (category: string, index: number = 0, top: number = 0, left: number = 0) => {

      const newPreviewPosition = ([...previewPosition])
         .filter(position => position.index !== index && position.category === category);

      newPreviewPosition.push({
         category: category,
         index: index,
         top: top, 
         left:left
      })

      dispatch({ type: SET_PREVIEW_POSITION, previewPosition: newPreviewPosition });
   }

   const clearPosition: Function = () => {
      dispatch({ type: SET_PREVIEW_POSITION, previewPosition: [] });
   }
   
   const clear: Function = () => {
      dispatch({ type: SET_CATEGORY, category: 'facebook' });
      dispatch({ type: SET_ITEMS, items: [] });
      dispatch({ type: SET_SELECTED, selected: [] });
      dispatch({ type: SET_INDEX_UPDATE_PREVIEW, index: undefined });
      dispatch({ type: SET_PREVIEW_POSITION, previewPosition: [] });
   }

   return {
      previewCategory: category,
      previewEditIndex: index,
      previewItems: items,
      previewSelected: selected,
      previewSetCategory: setCategory,
      previewSetItems: setItems,
      previewSetSelected: setSelected,
      previewSetSelectUpdatePreview: setUpdatePreview, 
      previewClear: clear,
      previewSetPosition: setPreviewPosition,
      previewPosition: previewPosition,
      previewClearPosition: clearPosition
   }
}

